/*! @azure/msal-common v8.0.0 2022-11-07 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CacheRecord = /** @class */ (function () {
    function CacheRecord(accountEntity, idTokenEntity, accessTokenEntity, refreshTokenEntity, appMetadataEntity) {
        this.account = accountEntity || null;
        this.idToken = idTokenEntity || null;
        this.accessToken = accessTokenEntity || null;
        this.refreshToken = refreshTokenEntity || null;
        this.appMetadata = appMetadataEntity || null;
    }
    return CacheRecord;
}());

export { CacheRecord };
//# sourceMappingURL=CacheRecord.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-common/dist/cache/entities/CacheRecord.js
// module id = 134
// module chunks = 0